module.exports = "./img/1924576be55ff1f706df5e8908fd5f41.jpg";